import React, { Component, lazy } from 'react';
import { Props, State, connector } from './types';
import LoadingSpinner from 'components/loadingSpinner';
import { AssignmentPresentation } from './assignmentPresentation';
import { DynamicAssignmentContent } from './dynamicContent';
import { SuspenseWrapper } from 'components/suspenceWrapper';
import { api } from 'api';
import { accountManager } from 'utils/accountManager';

const LazyWrongTokenMessage = lazy(() => import('components/wrongTokenMessage'));

class AssignmentRouteComponent extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { isLoading: false };
  }
  private getData = async (token: string) => {
    const { setCurrentAssignmentAction } = this.props;
    this.setState({ isLoading: true });
    const assignment = await api.assignment.get(token);
    assignment && setCurrentAssignmentAction(assignment);
    this.setState({ isLoading: false });
  };

  componentDidMount() {
    const { match } = this.props;
    const { token } = match?.params;
    if (token) {
      this.getData(token);
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { assignment, email, justKeepEmailAction } = this.props;
    // i'm checking the details of a different assignment from my account
    if (prevProps.assignment === undefined && assignment !== undefined) {
      const { fornitoreEmail } = assignment;
      if (email.length && fornitoreEmail && email.trim() !== fornitoreEmail.trim()) {
        accountManager.removeAllLoginData();
        justKeepEmailAction();
      }
    }
  }

  render() {
    const { assignment, isMobileScreen } = this.props;
    const { isLoading } = this.state;
    if (isLoading) {
      return <LoadingSpinner position="fixed" />;
    }
    if (assignment) {
      return (
        <>
          <AssignmentPresentation assignment={assignment} isMobileScreen={isMobileScreen} />
          {/* dynamic data */}
          <SuspenseWrapper>
            <DynamicAssignmentContent assignment={assignment} />
          </SuspenseWrapper>
        </>
      );
    }
    return <LazyWrongTokenMessage />;
  }
}

const AssignmentRoute = connector(AssignmentRouteComponent);

export default AssignmentRoute;
